export function formatTeamTenure(startDate: string | undefined, now = new Date()): string | null {
  const match = String(startDate || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  const start = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (
    start.getFullYear() !== Number(match[1])
    || start.getMonth() !== Number(match[2]) - 1
    || start.getDate() !== Number(match[3])
  ) return null;

  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (start > today) {
    return `Starts ${start.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}`;
  }

  let months = (today.getFullYear() - start.getFullYear()) * 12 + today.getMonth() - start.getMonth();
  if (today.getDate() < start.getDate()) months -= 1;
  if (months < 1) return 'Joined this month';
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  const parts = [years ? `${years} ${years === 1 ? 'yr' : 'yrs'}` : '', remainingMonths ? `${remainingMonths} mos` : ''].filter(Boolean);
  return `${parts.join(' ')} on team`;
}
